import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TextFilterHeaderComponent } from './text-filter-header.component';
import { TextFilterItemComponent } from './text-filter-item.component';
import { TextFilterComponent } from './text-filter.component';

@NgModule({
    declarations: [
        TextFilterComponent,
        TextFilterHeaderComponent,
        TextFilterItemComponent,
    ],
    exports: [
        TextFilterComponent,
        TextFilterHeaderComponent,
        TextFilterItemComponent,
    ],
    imports: [FormsModule],
})
export class CmpsTextFilterModule {}
